async function postPortalJson (endpoint, data) {
  var result = await fetch(`${process.env.VUE_APP_API_BASE_URL}portal/${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(data),
    redirect: 'follow'
  })
  return result.json()
}

export default postPortalJson
